export type RowKeyEvent = {
  key: string;
  target: EventTarget | null;
  currentTarget: EventTarget | null;
};

export function shouldActivateRow(e: RowKeyEvent): boolean {
  if (e.key !== 'Enter' && e.key !== ' ') return false;
  return e.target === e.currentTarget;
}
